import { STORAGE_KEYS } from '../config/constants';

export class ScoreManager {
  private highScores: number[] = [];
  bestHighScore: number = 0;
  highlightRank: number | null = null;
  highlightValue: number | null = null;

  constructor() {
    this.load();
  }

  clearHighlight(): void {
    this.highlightRank = null;
    this.highlightValue = null;
  }

  load(): number[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEYS.HIGH_SCORES);
      if (!raw) {
        this.highScores = [];
      } else {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          this.highScores = parsed
            .map(v => Number(v))
            .filter(n => Number.isFinite(n) && n > 0)
            .sort((a, b) => b - a)
            .slice(0, 10);
        }
      }
    } catch {
      this.highScores = [];
    }

    this.bestHighScore = this.highScores[0] || 0;
    return this.highScores;
  }

  save(): void {
    try {
      localStorage.setItem(STORAGE_KEYS.HIGH_SCORES, JSON.stringify(this.highScores));
    } catch {
      // Storage unavailable or quota exceeded
    }
  }

  recordScore(score: number): { added: boolean; rank: number | null; value: number } {
    const n = Math.floor(score);
    if (!Number.isFinite(n) || n <= 0) {
      return { added: false, rank: null, value: n };
    }

    const minScoreInList =
      this.highScores.length < 10 ? -Infinity : this.highScores[this.highScores.length - 1];

    if (this.highScores.length < 10 || n >= minScoreInList) {
      this.highScores.push(n);
      this.highScores.sort((a, b) => b - a);
      this.highScores = this.highScores.slice(0, 10);
      this.bestHighScore = this.highScores[0] || 0;
      this.save();

      const rank = this.highScores.indexOf(n);
      this.highlightRank = rank >= 0 ? rank : null;
      this.highlightValue = n;

      return { added: true, rank: this.highlightRank, value: n };
    }

    return { added: false, rank: null, value: n };
  }

  getScores(): number[] {
    return [...this.highScores];
  }
}
